import { render, staticRenderFns } from "./feRegister.vue?vue&type=template&id=892d0904&scoped=true"
import script from "./feRegister.vue?vue&type=script&lang=js"
export * from "./feRegister.vue?vue&type=script&lang=js"
import style0 from "../asset/css/login.scss?vue&type=style&index=0&id=892d0904&prod&lang=scss&scoped=true&external"
import style1 from "./feRegister.vue?vue&type=style&index=1&id=892d0904&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "892d0904",
  null
  
)

export default component.exports